import type { Language } from '@/types/locales';
import { usePageContext } from 'vike-react/usePageContext';
import { navigate } from 'vike/client/router';
import { getLinkHref } from '@/utils/getLinkHref';

export const useNavigate = () => {
    const pageContext = usePageContext();

    return (href: string, locale?: Language, options?: Parameters<typeof navigate>[1]) => {
        const newHref = getLinkHref(pageContext, href, locale);
        if (!newHref)
            return;
        return navigate(newHref, options);
    };
};
